import { createFileRoute, redirect } from "@tanstack/react-router"
import { useAuthStore } from "@/store/auth.store"

export const Route = createFileRoute("/overview")({
  beforeLoad: () => {
    const { isAuthenticated, user, buyerId, sellerProfileId, sellerCompanyId } = useAuthStore.getState()
    if (!isAuthenticated) {
      throw redirect({ to: "/explore", replace: true })
    }

    const role = user?.role?.toUpperCase()
    if (role === "BUYER") {
      if (!buyerId && !user?.buyer?.id) {
        throw redirect({ to: "/buyer-profile-setup" })
      }
      throw redirect({ to: "/explore", replace: true })
    }
    if (role === "SELLER") {
      if (!sellerProfileId && !user?.employeeProfile?.id) {
        throw redirect({ to: "/seller-profile-setup" })
      }
      if (!sellerCompanyId && !user?.employeeProfile?.companyId) {
        throw redirect({ to: "/seller-company-setup" })
      }
    }
  },
})
